import { jsonMember, jsonObject } from 'typedjson';
import { Guid } from '@web/utils';
import { InvoiceNumber } from '../../types';

@jsonObject
export class OrderRefundInvoiceResponse {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(String)
  public readonly number!: InvoiceNumber;
}
